import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { useParams, useNavigate } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import FranchiseeUpdateComponent from "./component";

const UpdateFranchiseeDetailsContainer = (props) => {
  const { franchiseeId, id, cohortId } = useParams();
  const navigate = useNavigate();
  const [updateFranchisee, setUpdateFranchisee] = useState({});
  const [loading, setLoading] = useState(false);
  const [formDataFranchisee, setFormDataFranchisee] = useState({});
  const [warehouseList, setWarehouseList] = useState([]);

  useEffect(() => {
    props.getDataFromAPI(
      `/dashboard/api/v2/admin/franchisee/${franchiseeId}`,
      "GET",
      undefined,
      (response) => {
        console.log("Franchisee API Response:", response);
        
        // Transform the API response to match your form structure
        const formDataWithNumbers = {
          ...response,
          cohortId: parseInt(response.cohortId),
          ownerId: Number(response.owner?.id || response.ownerId), 
          warehouseId: response.warehouse?.id, 
        };
        
        setUpdateFranchisee(response);
        setFormDataFranchisee(formDataWithNumbers);
        setLoading(true);
      },
      (err) => {
        console.log("error---", err);
        toastr.error("Failed", "Unable to fetch franchisee details");
      }
    );
  }, [franchiseeId, id, cohortId]);

  useEffect(() => {
    getWarehouseList();
  }, []);

const getWarehouseList = () => {
  props.getDataFromAPI(
    "/partner/api/v2/warehouse/list",
    "GET",
    undefined,
    (response) => {
      console.log("warehouseData:", response);
      // ✅ Map response data into proper format
      const normalizedList = response.map((wh) => ({
        id: wh.warehouseId,
        name: wh.warehouseName,
        city: wh.warehouseCity,
      }));
      setWarehouseList(normalizedList);
    },
    (err) => {
      console.log("error:", err);
      toastr.error("Failed", "Unable to fetch warehouse listing");
    }
  );
};


  const handleUpdateFranchisee = (event) => {
    const { name, value } = event.target;
    setFormDataFranchisee((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleApicallToUpdate = () => {
    handleChangeUpdateFranchisee();
  };

  const handleChangeUpdateFranchisee = async () => {
    // Prepare the data for the PATCH request
    const formDataToSend = {
      name: formDataFranchisee.name,
      description: formDataFranchisee.description,
      type: formDataFranchisee.type,
      ownerId: Number(formDataFranchisee.ownerId),
      warehouseId: formDataFranchisee.warehouseId ? Number(formDataFranchisee.warehouseId) : null,
      cohortId : parseInt(formDataFranchisee.cohortId)
    };

    console.log("Data being sent to API:", formDataToSend);

    try {
      const response = await props.getDataFromAPI(
        `/dashboard/api/v2/admin/franchisee/${franchiseeId}`,
        "PATCH",
        formDataToSend
      );

      console.log("Update response franchisee-------", response);
      toastr.success("Success", "Franchisee updated successfully");
      navigate(-1);
    } catch (error) {
      console.error("Error updating franchisee:", error);
      toastr.error("Failed", "Unable to update franchisee");
    }
  };

  return (
    <FranchiseeUpdateComponent
      loading={loading}
      formDataFranchisee={formDataFranchisee}
      handleUpdateFranchisee={handleUpdateFranchisee}
      handleApicallToUpdate={handleApicallToUpdate}
      warehouseList={warehouseList}
    />
  );
};

export default connect(null, {
  getDataFromAPI,
})(UpdateFranchiseeDetailsContainer);